import * as yup from 'yup';
import { stringReqSchema } from '../../../../utils';

const rules = yup.object({
  firstName: stringReqSchema('First name'),
  lastName: stringReqSchema('Last name'),
});

export default rules;
